export default __webpack_public_path__ + "static/media/img-mindmap-connect-your-mind-mobile.88e2f35e.png";